import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import BookingConfirmation from '../components/bookingconfirmation/BookingConfirmation';

const BookingConfirmationPage = () => {
	const { bookingGroupID } = useParams();

	return (
		<div>
			<Helmet>
				<title>Room 49 - Booking confirmation</title>
				<meta name="description" content="Booking confirmation for Room 49." />
				<link rel="canonical" href='https://thetypingrooms.co.uk/booking-confirmation' />
			</Helmet>
			<div className="page">
				<div className="page-header">
					<h1>Booking confirmation</h1>
				</div>
				<BookingConfirmation bookingGroupID={bookingGroupID} />
			</div>
		</div>

	);
};

export default BookingConfirmationPage;
